<template>
    <div>
        <h3 class="big-title">合作商家>></h3>
        <ul class="shop-ul">
            <li class="list">
                <img class="shop-img" src="../../assets/shop1.png" alt="" />
                <div class="des">
                    <h3>有家有爱生活用品</h3>
                    <p>描述相符：<span>5</span></p>
                    <p>服务态度：<span>5</span></p>
                    <p>发货速度：<span>5</span></p>
                </div>
            </li>
            <li class="list">
                <img class="shop-img" src="../../assets/shop2.png" alt="" />
                <div class="des">
                    <h3>宜居家用小物</h3>
                    <p>描述相符：<span>5</span></p>
                    <p>服务态度：<span>5</span></p>
                    <p>发货速度：<span>5</span></p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapMutations
    } from 'vuex';
    export default {
        components: {},
        data() {
            return {};
        },
        created() {
            // 在组件实例处理完所有与状态相关的选项后调用。
        },
        mounted() {
            // 在组件被挂载之后调用。
        },
        methods: {
            // ...mapMutations([])
        },
        computed: {
            // 计算属性
            // ...mapGetters([])
        },
        watch: {
            // 监听
        }
    };
</script>

<style lang="less" scoped>
    .list {
        padding: 15px;
        border-bottom: 1px solid #eee;
        display: flex;
    }

    .shop-img {
        width: 100px;
        margin-right: 25px;
    }

    .des {
        h3 {
            font-size: 20px;
        }
        p{
            margin-top: 10px;
            span{
                color: red;
            }
        }
    }
</style>